module.exports = __webpack_public_path__ + "img/athena_logo_singleline_500.fc1f373d.png";